module.exports = __webpack_public_path__ + "static/media/ana.ef0f343c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/squadBackgroundImg/ana.jpg
// module id = 724
// module chunks = 0